import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import {
  FiPlay,
  FiArrowRight,
  FiHeart,
  FiStar,
  FiClock,
  FiUsers,
  FiAward,
  FiScissors,
  FiPackage,
  FiShield,
} from "react-icons/fi";
import Footer from "../components/Footer";
import heroImg from "../assets/enfant.jpg";
import textureBg from "../assets/texture-paper.jpg";
import artisan1 from "../assets/artisan-1.jpg";
import leatherTexture from "../assets/leather-texture.jpg";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

const FabricationArtisanale = () => {
  const { scrollYProgress } = useScroll();
  const yPos = useTransform(scrollYProgress, [0, 1], [0, -300]);
  const scale = useTransform(scrollYProgress, [0, 0.5], [1, 1.1]);
  const navigate = useNavigate();

  const steps = [
    {
      title: "Sélection du cuir",
      description: "Choix méticuleux des peaux les plus nobles et résistantes",
      icon: FiPackage,
      duration: "2-3 heures",
      details:
        "Inspection visuelle et tactile de chaque peau pour garantir qualité et durabilité",
      bgImage:
        "https://i.pinimg.com/736x/94/83/8a/94838a8a5b9710d5e21342b1e5ae53f3.jpg",
    },
    {
      title: "Découpe artisanale",
      description: "Traçage et découpe à la main selon nos patrons exclusifs",
      icon: FiScissors,
      duration: "1-2 heures",
      details: "Précision millimétrique pour un ajustement parfait",
      bgImage:
        "https://i.pinimg.com/736x/9a/1f/6d/9a1f6d5835e4680b52cd72f873f5f921.jpg",
    },
    {
      title: "Broderie traditionnelle",
      description: "Points de couture ancestraux réalisés à la main",
      icon: FiHeart,
      duration: "3-4 heures",
      details: "Techniques ancestrales transmises de génération en génération",
      bgImage:
        "https://i.pinimg.com/1200x/35/74/a4/3574a46c646ffa6d757129f8aee77428.jpg",
    },
    {
      title: "Assemblage expert",
      description: "Montage précis pour un confort et une durabilité optimale",
      icon: FiShield,
      duration: "2-3 heures",
      details: "Assemblage final avec attention aux détails et finitions",
      bgImage:
        "https://i.pinimg.com/1200x/81/92/00/8192001e6e4a2731e0301c20f3f6e1f8.jpg",
    },
  ];

  const stats = [
    { number: "24/7", label: "Présence pour vous", icon: FiClock },
    { number: "15", label: "Années d'expérience", icon: FiUsers },
    { number: "100%", label: "Fait main", icon: FiHeart },
    { number: "5.0", label: "Note client", icon: FiStar },
  ];

  const [youtubeUrl, setYoutubeUrl] = useState(
    "https://www.youtube.com/embed/-I0nHGYT_XM"
  );

  useEffect(() => {
    axios
      .get(`${apiUrl}/api/fabart`)
      .then((res) => {
        if (res.data.youtubeUrl) {
          setYoutubeUrl(res.data.youtubeUrl);
        }
      })
      .catch((err) => {
        console.error("Erreur lors de la récupération de la vidéo :", err);
      });
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;800;900&family=Cormorant+Garamond:wght@300;400;500;600;700&family=Inter:wght@300;400;500;600;700&display=swap');
        
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          margin: 0;
          padding: 0;
          overflow-x: hidden;
          font-family: 'Cormorant Garamond', serif;
          background: linear-gradient(135deg, #f8f5f0 0%, #f0ebe0 100%);
        }

        .fabrication-container {
          font-family: 'Cormorant Garamond', serif;
          color: #2c1810;
          margin: 0 auto;
          overflow-x: hidden;
          background: linear-gradient(135deg, #f8f5f0 0%, #f0ebe0 100%);
        }

        /* Hero Section */
        .hero-section {
          position: relative;
          height: 100vh;
          min-height: 600px;
          background-image: linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url('${heroImg}');
          background-size: cover;
          background-position: center;
          background-attachment: fixed;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: white;
          text-align: center;
          margin-bottom: 60px;
        }

        .hero-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.3);
          backdrop-filter: blur(5px);
        }

        .hero-content {
          position: relative;
          z-index: 2;
          padding: 0 20px;
        }

        .hero-title {
          font-size: 3.5rem;
          font-weight: 600;
          margin-bottom: 20px;
          letter-spacing: 1px;
          text-shadow: 2px 2px 8px rgba(0,0,0,0.6);
          font-family: 'Cormorant Garamond', serif;
        }

        .hero-subtitle {
          font-size: 1.3rem;
          font-style: italic;
          text-shadow: 1px 1px 4px rgba(0,0,0,0.5);
          max-width: 800px;
          margin: 0 auto;
          line-height: 1.6;
          font-family: 'Cormorant Garamond', serif;
        }

        .scroll-indicator {
          margin-top: 60px;
          width: 60px;
          height: 60px;
          border: 2px solid rgba(255,255,255,0.7);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          margin-left: auto;
          margin-right: auto;
          transition: all 0.3s ease;
        }

        .scroll-indicator:hover {
          transform: scale(1.1);
          border-color: rgba(255,255,255,1);
        }

        .scroll-arrow {
          color: white;
          font-size: 24px;
          font-weight: 300;
        }

        /* Stats Section */
        .stats-section {
          padding: 80px 40px;
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(20px);
          position: relative;
          z-index: 10;
          margin-top: -80px;
          border-radius: 25px 25px 0 0;
          border: 1px solid rgba(212, 175, 55, 0.2);
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
        }

        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 35px;
          max-width: 1200px;
          margin: 0 auto;
        }

        .stat-card {
          text-align: center;
          padding: 35px 25px;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(15px);
          border-radius: 20px;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
          border: 1px solid rgba(212, 175, 55, 0.2);
        }

        .stat-card:hover {
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
          transform: translateY(-5px);
          border: 1px solid rgba(212, 175, 55, 0.3);
        }

        .stat-icon {
          width: 60px;
          height: 60px;
          margin: 0 auto 20px;
          background: rgba(212, 175, 55, 0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          color: #2c1810;
          transition: all 0.3s ease;
          border: 1px solid rgba(212, 175, 55, 0.3);
          backdrop-filter: blur(10px);
        }

        .stat-card:hover .stat-icon {
          background: rgba(212, 175, 55, 0.3);
          transform: scale(1.1);
          border: 1px solid rgba(212, 175, 55, 0.4);
        }

        .stat-number {
          font-size: 2rem;
          font-weight: 600;
          color: #2c1810;
          margin-bottom: 10px;
          font-family: 'Cormorant Garamond', serif;
        }

        .stat-label {
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 1px;
          color: #5a4a3a;
          font-weight: 500;
          font-family: 'Cormorant Garamond', serif;
        }

        /* Introduction Section */
        .intro-section {
          padding: 60px 20px;
          text-align: center;
          position: relative;
          margin-bottom: 80px;
        }

        .intro-content {
          max-width: 900px;
          margin: 0 auto;
        }

        .section-title {
          font-size: 2.5rem;
          font-weight: 600;
          margin-bottom: 30px;
          color: #2c1810;
          font-family: 'Cormorant Garamond', serif;
          position: relative;
          display: inline-block;
        }

        .section-title::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 2px;
          background: #d4af37;
          border-radius: 1px;
        }

        .intro-text {
          font-size: 18px;
          line-height: 1.8;
          margin-bottom: 40px;
          color: #5a4a3a;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
          font-family: 'Cormorant Garamond', serif;
        }

        .cta-button {
          display: inline-flex;
          align-items: center;
          gap: 12px;
          padding: 15px 30px;
          background: rgba(212, 175, 55, 0.2);
          color: #2c1810;
          border: 1px solid rgba(212, 175, 55, 0.3);
          border-radius: 15px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 16px rgba(212, 175, 55, 0.2);
          text-decoration: none;
          backdrop-filter: blur(10px);
          font-family: 'Cormorant Garamond', serif;
          text-transform: uppercase;
        }

        .cta-button:hover {
          background: rgba(212, 175, 55, 0.3);
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(212, 175, 55, 0.3);
        }

        /* Process Section */
        .process-section {
          padding: 80px 20px;
          background: rgba(255, 255, 255, 0.05);
          margin-bottom: 80px;
          position: relative;
          overflow: hidden;
          backdrop-filter: blur(20px);
          border: 1px solid rgba(212, 175, 55, 0.2);
        }

        .process-section::before {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          width: 40%;
          height: 100%;
          background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"><path fill="%23d4af37" fill-opacity="0.03" d="M50,0 C60,20 80,30 100,50 C80,70 60,80 50,100 C40,80 20,70 0,50 C20,30 40,20 50,0 Z"></path></svg>');
          background-size: 150px;
          opacity: 0.6;
        }

        .steps-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 35px;
          margin: 50px auto 0;
          position: relative;
          z-index: 2;
        }

        .step-card {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(15px);
          border-radius: 20px;
          padding: 35px 25px;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
          background-size: cover;
          background-position: center;
          color: white;
          border: 1px solid rgba(212, 175, 55, 0.2);
        }

        .step-card:hover {
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
          transform: translateY(-5px);
          border: 1px solid rgba(212, 175, 55, 0.3);
        }

        .step-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 25px;
          position: relative;
          z-index: 3;
        }

        .step-icon {
          font-size: 1.5rem;
          background: rgba(255, 255, 255, 0.2);
          width: 50px;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          color: white;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.3);
        }

        .step-card:hover .step-icon {
          background: rgba(255, 255, 255, 0.3);
          transform: scale(1.1);
          border: 1px solid rgba(255, 255, 255, 0.4);
        }

        .step-number {
          width: 35px;
          height: 35px;
          background: rgba(255, 255, 255, 0.2);
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 20px;
          border: 1px solid rgba(255, 255, 255, 0.3);
          backdrop-filter: blur(10px);
        }

        .step-title {
          font-size: 1.3rem;
          font-weight: 600;
          color: white;
          margin-bottom: 15px;
          font-family: 'Cormorant Garamond', serif;
          position: relative;
          z-index: 3;
        }

        .step-description {
          font-size: 16px;
          color: rgba(255,255,255,0.9);
          line-height: 1.6;
          margin-bottom: 20px;
          position: relative;
          z-index: 3;
          font-family: 'Cormorant Garamond', serif;
        }

        .step-duration {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          color: #d4af37;
          font-weight: 600;
          margin-bottom: 15px;
          position: relative;
          z-index: 3;
          font-family: 'Cormorant Garamond', serif;
        }

        .step-details {
          font-size: 14px;
          color: rgba(255,255,255,0.8);
          line-height: 1.5;
          font-style: italic;
          position: relative;
          z-index: 3;
          font-family: 'Cormorant Garamond', serif;
        }

        /* Video Section */
        .video-section {
          padding: 80px 20px;
          text-align: center;
          margin-bottom: 80px;
        }

        .video-container {
          max-width: 1000px;
          margin: 50px auto 0;
          position: relative;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 8px 32px rgba(0,0,0,0.1);
          aspect-ratio: 16/9;
          border: 1px solid rgba(212, 175, 55, 0.2);
          backdrop-filter: blur(15px);
        }

        .video-background {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: url('${leatherTexture}');
          background-size: cover;
          z-index: -1;
        }

        .video-iframe {
          width: 100%;
          height: 100%;
          border: none;
          position: relative;
          z-index: 1;
        }

        .video-overlay {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 2;
          pointer-events: none;
        }

        .play-icon {
          font-size: 3rem;
          color: rgba(255,255,255,0.8);
        }

        /* Testimonial Section */
        .testimonial-section {
          padding: 80px 20px;
          text-align: center;
          max-width: 1000px;
          margin: 0 auto 80px;
        }

        .artisan-photo {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          overflow: hidden;
          border: 3px solid rgba(212, 175, 55, 0.3);
          box-shadow: 0 4px 16px rgba(0,0,0,0.1);
          margin: 0 auto 40px;
          backdrop-filter: blur(10px);
        }

        .artisan-photo img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .testimonial-text {
          font-size: 18px;
          line-height: 1.8;
          color: #5a4a3a;
          max-width: 700px;
          margin: 0 auto 40px;
          font-style: italic;
          position: relative;
          padding: 0 20px;
          font-family: 'Cormorant Garamond', serif;
        }

        .testimonial-text::before,
        .testimonial-text::after {
          content: '"';
          font-size: 3rem;
          color: #d4af37;
          opacity: 0.3;
          position: absolute;
          line-height: 1;
        }

        .testimonial-text::before {
          top: -15px;
          left: 0;
        }

        .testimonial-text::after {
          bottom: -30px;
          right: 0;
        }

        .artisan-name {
          font-weight: 600;
          color: #2c1810;
          letter-spacing: 1px;
          font-size: 16px;
          font-family: 'Cormorant Garamond', serif;
        }

        /* Quality Section */
        .quality-section {
          padding: 80px 20px;
          background: rgba(255, 255, 255, 0.05);
          margin-bottom: 80px;
          backdrop-filter: blur(20px);
          border: 1px solid rgba(212, 175, 55, 0.2);
        }

        .quality-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 35px;
          max-width: 1200px;
          margin: 50px auto 0;
        }

        .quality-card {
          text-align: center;
          padding: 35px 25px;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(15px);
          border-radius: 20px;
          box-shadow: 0 4px 16px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
          border: 1px solid rgba(212, 175, 55, 0.2);
        }

        .quality-card:hover {
          box-shadow: 0 8px 25px rgba(0,0,0,0.15);
          transform: translateY(-5px);
          border: 1px solid rgba(212, 175, 55, 0.3);
        }

        .quality-icon {
          font-size: 2.5rem;
          color: #2c1810;
          margin-bottom: 20px;
          transition: all 0.3s ease;
        }

        .quality-card:hover .quality-icon {
          transform: scale(1.1);
          color: #d4af37;
        }

        .quality-card h3 {
          font-size: 1.3rem;
          font-weight: 600;
          color: #2c1810;
          margin-bottom: 15px;
          font-family: 'Cormorant Garamond', serif;
        }

        .quality-card p {
          font-size: 16px;
          color: #5a4a3a;
          line-height: 1.6;
          font-family: 'Cormorant Garamond', serif;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .stats-grid {
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 30px;
          }

          .steps-grid {
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 30px;
          }

          .quality-grid {
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 30px;
          }
        }

        @media (max-width: 768px) {
          .hero-content {
            padding: 0 20px;
          }

          .hero-title {
            font-size: 2.5rem;
          }

          .hero-subtitle {
            font-size: 1.1rem;
          }

          .stats-section,
          .intro-section,
          .process-section,
          .video-section,
          .testimonial-section,
          .quality-section {
            padding: 60px 20px;
          }

          .stats-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
          }

          .steps-grid {
            grid-template-columns: 1fr;
            gap: 30px;
          }

          .quality-grid {
            grid-template-columns: 1fr;
            gap: 30px;
          }

          .step-card {
            padding: 30px 25px;
          }

          .quality-card {
            padding: 35px 25px;
          }

          .section-title {
            font-size: 2rem;
          }
        }

        @media (max-width: 480px) {
          .hero-title {
            font-size: 2rem;
            letter-spacing: 1px;
          }

          .hero-subtitle {
            font-size: 1rem;
          }

          .stats-grid {
            grid-template-columns: 1fr;
          }

          .stat-card {
            padding: 25px 20px;
          }

          .step-card {
            padding: 25px 20px;
          }

          .quality-card {
            padding: 30px 20px;
          }
        }
      `}</style>

      <div className="fabrication-container">
        {/* Hero Section */}
        <motion.section className="hero-section" style={{ y: yPos, scale }}>
          <div className="hero-overlay" />
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4, duration: 1 }}
            className="hero-content"
          >
            <motion.h1
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.6, duration: 0.8 }}
              className="hero-title"
            >
              L'Art de la Babouche
            </motion.h1>
            <motion.p
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.8, duration: 0.8 }}
              className="hero-subtitle"
            >
              Un savoir-faire ancestral transmis avec passion depuis des
              générations
            </motion.p>
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 1.2, type: "spring" }}
              className="scroll-indicator"
              onClick={() => {
                window.scrollTo({
                  top: window.innerHeight,
                  behavior: "smooth",
                });
              }}
              style={{ cursor: "pointer" }}
            >
              <motion.div
                animate={{ y: [0, 10, 0] }}
                transition={{ repeat: Infinity, duration: 2 }}
                className="scroll-arrow"
              >
                ↓
              </motion.div>
            </motion.div>
          </motion.div>
        </motion.section>

        {/* Stats Section */}
        <motion.section
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="stats-section"
        >
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.1, duration: 0.6 }}
                viewport={{ once: true }}
                className="stat-card"
              >
                <div className="stat-icon">
                  <stat.icon />
                </div>
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </motion.section>

        {/* Introduction Section */}
        <motion.section
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="intro-section"
        >
          <div className="intro-content">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.8 }}
              viewport={{ once: true }}
              className="section-title"
            >
              L'Excellence du Fait Main
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.8 }}
              viewport={{ once: true }}
              className="intro-text"
            >
              Chez <strong>SAFA</strong>, chaque babouche est une œuvre d'art
              née de l'alliance entre savoir-faire ancestral et exigence
              contemporaine. Nos artisans consacrent jusqu'à{" "}
              <strong>8 heures de travail minutieux</strong> pour créer une
              paire unique.
            </motion.p>
            <motion.button
              onClick={() => navigate("/about")}
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
              className="cta-button"
            >
              Découvrir notre Marque
              <FiArrowRight />
            </motion.button>
          </div>
        </motion.section>

        {/* Process Steps */}
        <motion.section
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          className="process-section"
        >
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.8 }}
            viewport={{ once: true }}
            className="section-title"
            style={{
              textAlign: "center",
              display: "flex",
              justifySelf: "center",
            }}
          >
            Notre Processus Artisanal
          </motion.h2>

          <div className="steps-grid">
            {steps.map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 + 0.3, duration: 0.6 }}
                viewport={{ once: true }}
                whileHover={{ y: -10, scale: 1.02 }}
                className="step-card"
                style={{
                  backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${step.bgImage})`,
                }}
              >
                <div className="step-header">
                  <div className="step-icon">
                    <step.icon />
                  </div>
                  <div className="step-number">{index + 1}</div>
                </div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
                <div className="step-duration">
                  <FiClock />
                  {step.duration}
                </div>
                <p className="step-details">{step.details}</p>
              </motion.div>
            ))}
          </div>
        </motion.section>

        {/* Video Section */}
        <motion.section
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          className="video-section"
        >
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.8 }}
            viewport={{ once: true }}
            className="section-title"
          >
            L'Artisanat en Mouvement
          </motion.h2>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="video-container"
          >
            <div className="video-background" />
            <iframe
              src={youtubeUrl}
              title="Vidéo fabrication babouches"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="video-iframe"
            />
            <div className="video-overlay">
              <FiPlay className="play-icon" />
            </div>
          </motion.div>
        </motion.section>

        {/* Artisan Testimonial */}
        <motion.section
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          className="testimonial-section"
        >
          <motion.div
            initial={{ rotate: -5, scale: 0.9 }}
            whileInView={{ rotate: 0, scale: 1 }}
            transition={{ type: "spring", stiffness: 100 }}
            viewport={{ once: true }}
            className="artisan-photo"
          >
            <img src={artisan1} alt="Artisan" />
          </motion.div>

          <motion.blockquote
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            viewport={{ once: true }}
            className="testimonial-text"
          >
            "Chaque babouche que je crée porte une partie de mon histoire. C'est
            plus qu'un métier, c'est une passion héritée de mes aïeux que je
            transmets à mon tour avec fierté."
          </motion.blockquote>

          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.7, duration: 0.8 }}
            viewport={{ once: true }}
            className="artisan-name"
          >
            Ahmed, Maître Artisan depuis 1987
          </motion.p>
        </motion.section>

        {/* Quality Section */}
        <motion.section
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="quality-section"
        >
          <motion.h2 style={{display:"flex", justifySelf:"center"}}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.8 }}
            viewport={{ once: true }}
            className="section-title"
          >
            Notre Engagement Qualité
          </motion.h2>

          <div className="quality-grid">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.3, duration: 0.8 }}
              viewport={{ once: true }}
              className="quality-card"
            >
              <FiAward className="quality-icon" />
              <h3>Excellence Artisanale</h3>
              <p>
                Chaque détail est soigneusement travaillé pour garantir une
                qualité exceptionnelle
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.5, duration: 0.8 }}
              viewport={{ once: true }}
              className="quality-card"
            >
              <FiHeart className="quality-icon" />
              <h3>Passion Authentique</h3>
              <p>L'amour du métier se ressent dans chaque point de couture</p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.7, duration: 0.8 }}
              viewport={{ once: true }}
              className="quality-card"
            >
              <FiStar className="quality-icon" />
              <h3>Tradition Respectée</h3>
              <p>Les techniques ancestrales sont préservées et transmises</p>
            </motion.div>
          </div>
        </motion.section>

        <Footer />
      </div>
    </>
  );
};

export default FabricationArtisanale;
